jQuery(document).ready(function ($) {

    $('.js-collapsible--expanded .js-collapsible__content').show();

    $(document).on('click', '.js-collapsible__trigger', function () {
        if ($(this).parents('.js-collapsible').hasClass('js-collapsible--expanded')) {
            $(this).parents('.js-collapsible').removeClass('js-collapsible--expanded').find('.js-collapsible__content').stop().slideUp(300);
        } else {
            $(this).parents('.js-collapsible').addClass('js-collapsible--expanded').find('.js-collapsible__content').stop().slideDown(300);
        }
    });

    $('.js-expand').on('click', function () {
        var $this = $(this),
            parent = $this.parents('.row-slider-review__content'),
            slide = parent.find('.slide'),
            titleHeight = slide.find('.js-review').outerHeight(true),
            textHeight = slide.find('.js-response')[0] ? slide.find('.js-response').outerHeight(true) : 0;

        if ($this.hasClass('is-active')) {
            $this.removeClass('is-active').find('.show-more').text('+ Toon meer');
            slide.css({'max-height': '165px'})
        } else {
            $this.addClass('is-active').find('.show-more').text('- Toon minder');
            slide.css({'max-height': titleHeight + textHeight + 'px'})
        }
    });
});
